import { render, staticRenderFns } from "./main-visual-flebogrif.vue?vue&type=template&id=348f13e6&scoped=true"
import script from "./main-visual-flebogrif.vue?vue&type=script&lang=js"
export * from "./main-visual-flebogrif.vue?vue&type=script&lang=js"
import style0 from "./main-visual-flebogrif.vue?vue&type=style&index=0&id=348f13e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "348f13e6",
  null
  
)

export default component.exports